import { useModals } from 'almanac-ui/Modal'
import { ChangeLengthModal } from 'components/BlazeCommandLine/modals/ChangeLengthModal'
import { Button } from 'components/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { AllSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { useAlmanacEditorState } from 'stores/EditorState'
import { ReceiptLines } from 'blaze-ui/icons'

interface Props {
  articleId: string
  layerId: string
  view: EditorView
}

export const ChangeLengthAction = ({ articleId, layerId, view }: Props) => {
  const { openModal } = useModals()
  const almanacEditorState = useAlmanacEditorState() || undefined
  const selection = new AllSelection(view.state.doc).toJSON()
  const { isMobile } = useResponsiveDesign()

  const handlePress = () => {
    openModal(ChangeLengthModal, {
      articleId,
      layerId,
      selection,
      almanacEditorState,
    })
  }

  return (
    <Button
      aria-label="Change length"
      variant="tertiary"
      size="lg"
      frontIcon={() => <ReceiptLines size={24} />}
      onPress={handlePress}
      id="change-length"
    >
      {isMobile ? 'Length' : 'Change Length'}
    </Button>
  )
}
